import { AppBar, Box, Toolbar, Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

type Props = {
    title: string
}

const Header = ({ title }: Props) => {
    const isDesktopOrLaptop = useMediaQuery('(min-width:1224px)');
    const variant = isDesktopOrLaptop ? "h4" : "h5";

    return <Box>
        <AppBar component="nav" sx={{ backgroundColor: '#343A40' }}>
            <Toolbar sx={{ justifyContent: 'center' }}>
                <Typography variant={variant} component="div">{title}</Typography>
            </Toolbar>
        </AppBar>
    </Box>
}

export default Header;